import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import { ChatWidget } from "./components/ChatWidget";

// Pages
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import FilosofiaPage from "./pages/FilosofiaPage";
import ClubPage from "./pages/ClubPage";
import PreLovedPage from "./pages/PreLovedPage";
import ContattiPage from "./pages/ContattiPage";
import SpedizioniResiPage from "./pages/SpedizioniResiPage";
import FaqPage from "./pages/FaqPage";
import GuidaTagliePage from "./pages/GuidaTagliePage";
import TerminiPage from "./pages/TerminiPage";
import PrivacyPage from "./pages/PrivacyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import AccountPage from "./pages/AccountPage";
import AccountOrdersPage from "./pages/AccountOrdersPage";
import AccountWishlistPage from "./pages/AccountWishlistPage";
import AccountTradeInPage from "./pages/AccountTradeInPage";
import AdminPage from "./pages/AdminPage";
import AdminProductsPage from "./pages/AdminProductsPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminTradeInsPage from "./pages/AdminTradeInsPage";
import AdminReviewsPage from "./pages/AdminReviewsPage";
import WardrobePage from "./pages/WardrobePage";
import SharedOutfitPage from "./pages/SharedOutfitPage";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallbackPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/product/:productId" element={<ProductPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
      <Route path="/trade-in" element={<Navigate to="/club" replace />} />
      <Route path="/filosofia" element={<FilosofiaPage />} />
      <Route path="/club" element={<ClubPage />} />
      <Route path="/pre-loved" element={<PreLovedPage />} />
      <Route path="/contatti" element={<ContattiPage />} />
      <Route path="/spedizioni-resi" element={<SpedizioniResiPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/guida-taglie" element={<GuidaTagliePage />} />
      <Route path="/termini" element={<TerminiPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      <Route path="/guardaroba" element={<WardrobePage />} />
      <Route path="/outfit/:token" element={<SharedOutfitPage />} />
      
      {/* Account Routes */}
      <Route path="/account" element={<AccountPage />}>
        <Route path="orders" element={<AccountOrdersPage />} />
        <Route path="wishlist" element={<AccountWishlistPage />} />
        <Route path="trade-in" element={<AccountTradeInPage />} />
      </Route>

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminPage />}>
        <Route path="products" element={<AdminProductsPage />} />
        <Route path="orders" element={<AdminOrdersPage />} />
        <Route path="trade-ins" element={<AdminTradeInsPage />} />
        <Route path="reviews" element={<AdminReviewsPage />} />
      </Route>
    </Routes>
  );
}

function AppContent() {
  const location = useLocation();
  const hideFooter = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      <Header />
      <main>
        <AppRouter />
      </main>
      {!hideFooter && <Footer />}
      {!hideFooter && <ChatWidget />}
      <CookieConsent />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <AppContent />
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
